/**
 * @generated SignedSource<<4d72b74291f63859a8cca6741db5a77e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type Currency = "AUD" | "CAD" | "CHF" | "DKK" | "EUR" | "GBP" | "JPY" | "MXN" | "NOK" | "SEK" | "USD" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type CheckoutMobileSummaryPane_transaction$data = {
  readonly buyerChargeCurrency: Currency | null;
  readonly isNegotiable: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutAvalaraTaxExempt_transaction" | "CheckoutDutiesMessage_transaction" | "CheckoutMobileSummaryPaneTitle_transaction" | "CheckoutMobileSummaryPriceTable_transaction" | "CheckoutSidebarPromotion_transaction" | "CheckoutSummaryItemSkuDetails_transaction" | "CheckoutTotalsDutiesMessage_transaction">;
  readonly " $fragmentType": "CheckoutMobileSummaryPane_transaction";
};
export type CheckoutMobileSummaryPane_transaction$key = {
  readonly " $data"?: CheckoutMobileSummaryPane_transaction$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutMobileSummaryPane_transaction">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutMobileSummaryPane_transaction",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutMobileSummaryPaneTitle_transaction"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutSummaryItemSkuDetails_transaction"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutMobileSummaryPriceTable_transaction"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutSidebarPromotion_transaction"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutDutiesMessage_transaction"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutTotalsDutiesMessage_transaction"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutAvalaraTaxExempt_transaction"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "buyerChargeCurrency",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isNegotiable",
      "storageKey": null
    }
  ],
  "type": "Transaction",
  "abstractKey": null
};

(node as any).hash = "2a66a718e674ffe7d400f8f4844c1586";

export default node;
